export interface FormatCurrencyOptions {
  /** Use compact notation for large amounts, e.g. "£12.5K". */
  compact?: boolean;
}

const PENCE_PER_POUND = 100;

/** Format an amount in pence as a GBP currency string, e.g. 123456 -> "£1,234.56". */
export function formatCurrencyGBP(
  valuePence: number,
  options?: FormatCurrencyOptions,
): string {
  if (options?.compact) {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
      notation: "compact",
      maximumFractionDigits: 1,
    }).format(valuePence / PENCE_PER_POUND);
  }
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
  }).format(valuePence / PENCE_PER_POUND);
}

/**
 * Parse a user-typed currency string to a number, e.g. "£1,234.50" -> 1234.5.
 * Returns the pound amount (not pence), or null when empty/invalid.
 */
export function parseCurrencyInput(input: string): number | null {
  const cleaned = input.replace(/[£,]/g, "").trim();
  if (cleaned === "") {
    return null;
  }
  const parsed = Number(cleaned);
  if (Number.isNaN(parsed)) {
    return null;
  }
  return parsed;
}

/**
 * Format a pound-denominated amount (the portal API convention) as GBP, e.g.
 * 570 -> "£570.00". Rounds to whole pence before converting.
 */
export function formatCurrencyGBPPounds(valuePounds: number): string {
  return formatCurrencyGBP(Math.round(valuePounds * PENCE_PER_POUND));
}
